import { Link } from 'react-router-dom'

export function Home() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-8">
      <div className="text-center space-y-6">
        <h1 className="text-4xl font-bold text-forest-dark">
          Family Budget
        </h1>
        <p className="text-lg text-sage max-w-md">
          Track income, expenses, assets, and savings goals for your family.
        </p>
        <Link
          to="/login"
          className="inline-block px-6 py-3 bg-forest text-white rounded-lg hover:bg-forest-dark transition-colors"
        >
          Sign In
        </Link>
      </div>
    </main>
  )
}
